/**
 * Normalize size-chart modals: strip page inline styles, hide redundant chrome,
 * merge paired body/product tables when present.
 */
(function () {
  function normalizeSize(text) {
    return (text || '').trim().toUpperCase();
  }

  function stripInlineStyles(modal) {
    modal.querySelectorAll('style').forEach((node) => node.remove());
  }

  function normalizeTables(modal) {
    const info = modal.querySelector('.product-popup-modal__content-info');
    if (!info) return;

    info.querySelectorAll('table').forEach((table) => {
      table.classList.add('size-chart__table');

      if (!table.closest('.size-chart__table-wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'size-chart__table-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      }
    });

    info.querySelectorAll('caption').forEach((caption) => {
      caption.hidden = true;
    });

    info.querySelectorAll('.size-chart h2, .size-chart h3').forEach((heading) => {
      heading.hidden = true;
    });
  }

  function combineSizeChartTables(section) {
    if (section.dataset.sizeChartMerged === 'true') return;

    const wrappers = section.querySelectorAll(':scope > .size-chart__table-wrapper');
    if (wrappers.length !== 2) return;
    if (section.classList.contains('size-chart--dual')) return;

    const table1 = wrappers[0].querySelector('table.size-chart__table');
    const table2 = wrappers[1].querySelector('table.size-chart__table');
    if (!table1 || !table2) return;

    const head1 = table1.querySelector('thead tr');
    const head2 = table2.querySelector('thead tr');
    const rows1 = [...table1.querySelectorAll('tbody tr')];
    const rows2 = [...table2.querySelectorAll('tbody tr')];

    if (!head1 || !head2 || rows1.length !== rows2.length || rows1.length === 0) return;

    for (let i = 0; i < rows1.length; i++) {
      const size1 = rows1[i].querySelector('th, td')?.textContent;
      const size2 = rows2[i].querySelector('th, td')?.textContent;
      if (normalizeSize(size1) !== normalizeSize(size2)) return;
    }

    head2.querySelectorAll('th').forEach((th, index) => {
      if (index === 0) return;
      head1.appendChild(th.cloneNode(true));
    });

    rows1.forEach((row1, index) => {
      rows2[index].querySelectorAll('td').forEach((td) => {
        row1.appendChild(td.cloneNode(true));
      });
    });

    wrappers[1].hidden = true;

    const notes = section.querySelectorAll(':scope > .size-chart__note');
    if (notes.length > 1) notes[1].hidden = true;

    section.dataset.sizeChartMerged = 'true';
    section.classList.add('size-chart--combined');
  }

  function initModal(modal) {
    if (modal.dataset.sizeChartReady === 'true') return;
    stripInlineStyles(modal);
    normalizeTables(modal);
    modal.querySelectorAll('.size-chart').forEach(combineSizeChartTables);
    modal.dataset.sizeChartReady = 'true';
  }

  function init() {
    document.querySelectorAll('.product-popup-modal--size-chart').forEach(initModal);
  }

  function watchModals() {
    document.querySelectorAll('.product-popup-modal--size-chart').forEach((modal) => {
      const observer = new MutationObserver(() => {
        if (modal.hasAttribute('open')) initModal(modal);
      });
      observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      watchModals();
    });
  } else {
    init();
    watchModals();
  }
})();
